import type { FC } from 'react';
import { Button } from '../../components/Button';
import { CreateProfileModal } from './CreateProfileModal';
import { useProxyProfiles } from './hooks/useProxyProfiles';
import { ProfileCard } from './ProfileCard';
import { ProfileEditor } from './ProfileEditor';
import styles from './ProxyConfig.module.css';

export const ProxyConfig: FC = () => {
  const {
    profiles,
    loading,
    showCreateModal,
    viewingProfile,
    testResults,
    authTestResults,
    mleTestResults,
    testUrl,
    setTestUrl,
    createFormData,
    setCreateFormData,
    profileFormData,
    setProfileFormData,
    saveTestUrl,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleOpenProfile,
    handleCloseProfile,
    handleCreateProfile,
    handleUpdateProfile,
    handleDelete,
    handleTestProfile,
    handleTestAuth,
    handleTestMle,
    handleFileUpload,
    handleMleFileUpload,
    handlePortalChange,
    handleP12Upload,
  } = useProxyProfiles();

  if (loading) {
    return <div className={styles.container}>Loading...</div>;
  }

  if (viewingProfile) {
    return (
      <ProfileEditor
        profile={viewingProfile}
        formData={profileFormData}
        onChange={setProfileFormData}
        testUrl={testUrl}
        onTestUrlChange={setTestUrl}
        onSaveTestUrl={saveTestUrl}
        onPortalChange={handlePortalChange}
        onSave={handleUpdateProfile}
        onBack={handleCloseProfile}
        onTestAuth={handleTestAuth}
        onTestMle={handleTestMle}
        authTestResults={authTestResults}
        mleTestResults={mleTestResults}
        onFileUpload={handleFileUpload}
        onMleFileUpload={handleMleFileUpload}
        onP12Upload={handleP12Upload}
      />
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Proxy Settings</h2>
        <Button variant="success" onClick={handleOpenCreateModal}>
          + Add New Profile
        </Button>
      </div>

      {profiles.length === 0 ? (
        <div className={styles.emptyState}>
          <h3>No proxy profiles found</h3>
          <p>Create your first proxy profile to get started</p>
        </div>
      ) : (
        <div className={styles.profilesGrid}>
          {profiles.map((profile) => (
            <ProfileCard
              key={profile.id}
              profile={profile}
              testResult={testResults[profile.id]}
              onEdit={handleOpenProfile}
              onTest={handleTestProfile}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}

      {showCreateModal && (
        <CreateProfileModal
          formData={createFormData}
          onChange={setCreateFormData}
          onSubmit={handleCreateProfile}
          onClose={handleCloseCreateModal}
        />
      )}
    </div>
  );
};
